import { Color, PaletteColorOptions, PaletteOptions } from '@mui/material/styles';

const grey: Partial<Color> = {
  50: '#EDEDED',
  100: '#eeeeee',
  200: '#d5d5d5',
  300: '#c1c1c1',
  400: '#a0a0a0',
  500: '#7f7f7f',
  600: '#6b6b6b',
  700: '#424242',
  800: '#424242',
  900: '#2F2F2F',
  A100: '#707070',
  A200: '#cccccc',
  A400: '#b0b0b0',
  A700: '#000000',
};

const primary: PaletteColorOptions = {
  light: '#99D8B9',
  main: '#7DCEA0',
  dark: '#57BE87',
  contrastText: '#FFFFFF',
};

const secondary: PaletteColorOptions = {
  light: '#4C8CBF',
  main: '#2874A6',
  dark: '#1D527C',
  contrastText: '#FFFFFF',
};

const info: PaletteColorOptions = {
  light: '#FFE966',
  main: '#F1C40F',
  dark: '#C29D0B',
  contrastText: '#000000',
};

const freshPalette: PaletteOptions = {
  mode: 'light',
  action: {
    disabled: 'rgba(0, 0, 0, 0.26)',
    disabledBackground: 'rgba(0, 0, 0, 0.12)',
  },
  common: { black: '#000', white: '#fff' },
  primary,
  secondary,
  info,
  grey,
  divider: '#D1D1D1',
  text: {
    primary: '#424242',
    secondary: '#475569',
    disabled: '#a0a0a0',
  },
  background: { paper: '#EDEDED', default: '#FFFFFF' },
};

export default freshPalette;
